import { FIXED_QUERY_SELECTOR } from '@hcs/webapps';

export const useFixedPortalElement = () =>
  document.querySelector<HTMLDivElement>(FIXED_QUERY_SELECTOR);
